var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "순회점검계획 정보" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [_c("q-btn-group", { attrs: { outline: "" } })],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-6 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        editable: _vm.editable && !_vm.disabled,
                        label: "순회일",
                        name: "patrolDate",
                      },
                      on: { datachange: _vm.placeChange },
                      model: {
                        value: _vm.place.patrolDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.place, "patrolDate", $$v)
                        },
                        expression: "place.patrolDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                  },
                  [
                    _c("c-multi-field", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        label: "점검자",
                        type: "user",
                        name: "checkUserId",
                      },
                      model: {
                        value: _vm.patrol.checkUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.patrol, "checkUserId", $$v)
                        },
                        expression: "patrol.checkUserId",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "순회 일상점검 Check-List",
                gridHeightAuto: true,
                columns: _vm.gridColumns,
                gridHeight: _vm.gridHeight,
                data: _vm.filterData,
                merge: _vm.grid.merge,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable && !_vm.disabled,
              },
              on: { "table-data-change": _vm.tableDataChange },
              scopedSlots: _vm._u([
                {
                  key: "custom-label-after",
                  fn: function ({ col }) {
                    return [
                      col.name === "saiEquipClassName"
                        ? _c(
                            "div",
                            [
                              _c("c-select", {
                                attrs: {
                                  stype: "tableHeaderselect",
                                  comboItems: _vm.equipComboItems,
                                  type: "custom",
                                  typetxt: "All",
                                  itemText: "codeName",
                                  itemValue: "code",
                                },
                                model: {
                                  value: _vm.filter.saiEquipClassName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filter,
                                      "saiEquipClassName",
                                      $$v
                                    )
                                  },
                                  expression: "filter.saiEquipClassName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      col.name === "saiItemClassName"
                        ? _c(
                            "div",
                            [
                              _c("c-select", {
                                attrs: {
                                  stype: "tableHeaderselect",
                                  comboItems: _vm.itemComboItems,
                                  type: "custom",
                                  typetxt: "All",
                                  itemText: "codeName",
                                  itemValue: "code",
                                },
                                model: {
                                  value: _vm.filter.saiItemClassName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filter,
                                      "saiItemClassName",
                                      $$v
                                    )
                                  },
                                  expression: "filter.saiItemClassName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "customArea",
                  fn: function ({ props }) {
                    return [
                      [
                        _c("q-btn", {
                          attrs: {
                            flat: "",
                            size: "12px",
                            color: "orange",
                            icon: "chevron_right",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.rowClickDetail(
                                props.row,
                                props.pageIndex
                              )
                            },
                          },
                        }),
                      ],
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-header-append" },
                [
                  _c("div", { staticClass: "slotAppentTitle" }, [
                    _vm._v("* 라인선택 "),
                  ]),
                  _c("c-select", {
                    attrs: {
                      comboItems: _vm.lineItems,
                      type: "none",
                      itemText: "lineCd",
                      itemValue: "lineId",
                      name: "lineCd",
                      label: "",
                    },
                    on: {
                      datachange: function ($event) {
                        return _vm.lineDatachange(false)
                      },
                    },
                    model: {
                      value: _vm.lineId,
                      callback: function ($$v) {
                        _vm.lineId = $$v
                      },
                      expression: "lineId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "template",
                { slot: "suffixTitle" },
                [
                  _c(
                    "font",
                    {
                      staticClass: "text-negative",
                      staticStyle: {
                        "font-size": "0.8em",
                        "font-weight": "300",
                      },
                    },
                    [_vm._v(" 양호(O) , 불량(X) , 즉조치(△) ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { position: _vm.positionDetail },
          model: {
            value: _vm.dialogDetail,
            callback: function ($$v) {
              _vm.dialogDetail = $$v
            },
            expression: "dialogDetail",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { width: "100%" } },
            [
              _c("q-linear-progress", { attrs: { value: 1, color: "pink" } }),
              _c("q-card-section", { staticClass: "row" }, [
                _c("div", {
                  staticClass: "col-12 text-weight-bold-dailog",
                  domProps: {
                    textContent: _vm._s(_vm.selectedRow.patrolItemName),
                  },
                }),
                _c("div", { staticClass: "col-4" }, [
                  _c("div", { staticClass: "mini-dailog-title" }, [
                    _vm._v("개선진행 상태"),
                  ]),
                ]),
                _c("div", { staticClass: "col-8 mini-dailog-btn-impr" }, [
                  _vm.editable &&
                  Boolean(_vm.selectedRow.saiPatrolResultId) &&
                  _vm.selectedRow.editFlag !== "C" &&
                  !_vm.disabled
                    ? _c(
                        "div",
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _vm.editable && !_vm.disabled
                                ? _c("c-btn", {
                                    attrs: {
                                      showLoading: false,
                                      label: "개선요청",
                                      color: "red-6",
                                      "text-color": "white",
                                    },
                                    on: {
                                      btnClicked: function ($event) {
                                        return _vm.innerBtnClicked(
                                          _vm.selectedRow,
                                          "1"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.editable && !_vm.disabled
                                ? _c("c-btn", {
                                    attrs: {
                                      showLoading: false,
                                      label: "즉시조치",
                                      color: "light-blue",
                                      "text-color": "white",
                                    },
                                    on: {
                                      btnClicked: function ($event) {
                                        return _vm.innerBtnClicked(
                                          _vm.selectedRow,
                                          "2"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 border-impr-dialog" },
                  [
                    _vm.selectedRow["sopImprovementIds"] &&
                    _vm.selectedRow["ibmStepNames"]
                      ? _vm._l(
                          _vm.$comm.ibmTagItems(
                            _vm.selectedRow,
                            _vm.colorItems
                          ),
                          function (item, index) {
                            return _c(
                              "q-chip",
                              {
                                key: index,
                                staticStyle: {
                                  "margin-bottom": "4px !important",
                                },
                                attrs: {
                                  color:
                                    item.ibmClassCd === "IC00000001"
                                      ? "blue-6"
                                      : "orange",
                                  clickable: true,
                                  "text-color": "white",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.linkClick(item, _vm.selectedRow)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            )
                          }
                        )
                      : [_vm._v(" 등록된 개선요청 및 즉시조치가 없습니다. ")],
                  ],
                  2
                ),
                _c("div", { staticClass: "col-12" }, [_vm._v("  ")]),
                _c("div", { staticClass: "col-4" }, [
                  _c("div", { staticClass: "mini-dailog-title" }, [
                    _vm._v("요청사항"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && !_vm.disabled,
                        label: "",
                        name: "dialogpatrolContents",
                      },
                      model: {
                        value: _vm.dialogpatrolContents,
                        callback: function ($$v) {
                          _vm.dialogpatrolContents = $$v
                        },
                        expression: "dialogpatrolContents",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 mini-dailog-btn-impr" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          attrs: {
                            showLoading: false,
                            label: "닫기",
                            icon: "close",
                          },
                          on: { btnClicked: _vm.dialogClose },
                        }),
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: {
                                showLoading: false,
                                label: "적용",
                                icon: "check",
                                color: "amber-7",
                              },
                              on: { btnClicked: _vm.dialogSubmit },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.disabled && _vm.editable,
                      expression: "disabled && editable",
                    },
                  ],
                  attrs: {
                    flat: true,
                    url: _vm.cancelUrl,
                    isSubmit: _vm.isCancel,
                    param: _vm.place,
                    mappingType: "PUT",
                    label: "완료취소",
                    icon: "restart_alt",
                  },
                  on: {
                    beforeAction: _vm.cancelPlace,
                    btnCallback: _vm.cancelCallback,
                  },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.disabled && _vm.editable,
                      expression: "!disabled && editable",
                    },
                  ],
                  attrs: {
                    flat: true,
                    url: _vm.saveUrl,
                    isSubmit: _vm.isSave,
                    param: _vm.place,
                    mappingType: "PUT",
                    label: "저장",
                    icon: "save",
                  },
                  on: {
                    beforeAction: _vm.savePlace,
                    btnCallback: _vm.saveCallback,
                  },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.disabled && _vm.editable,
                      expression: "!disabled && editable",
                    },
                  ],
                  attrs: {
                    flat: true,
                    url: _vm.completeUrl,
                    isSubmit: _vm.isComplete,
                    param: _vm.place,
                    mappingType: "PUT",
                    label: "완료",
                    icon: "check",
                  },
                  on: {
                    beforeAction: _vm.completePlace,
                    btnCallback: _vm.completeCallback,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }